// extracted by mini-css-extract-plugin
module.exports = {"root":"Dialog_root__1pXw0","wrapper":"Dialog_wrapper__1Xj-g","fullScreen":"Dialog_fullScreen__2AxzN","backdrop":"Dialog_backdrop__1-q1V","paper":"Dialog_paper__SEgt9"};